/* eslint-disable camelcase */
// eslint-disable-next-line max-classes-per-file
import moment from 'moment';
import { TLocksButtonVisibility } from '@treedis/tour-loader';
import { GameBook } from './game/GameBook';
import { ConditionLocationType } from '@/components/types';
import { parsePathDestinationSweepData } from '@/_helpers/base';

export enum Res {
  Percentage = 'percentage',
  Pixels = 'pixels',
}

export enum GameTimerType {
  CountDown = 'countdown',
  StopWatch = 'stopwatch',
}
export enum ScoreType {
  Progress = 'progress',
  Points = 'points',
}

export enum LockType {
  Code = 'code',
  Keyboard = 'keyboard',
  Sequence = 'sequence',
  PopUpTrivia = 'popUpTrivia',
  CollectItems = 'collectItems',
  Path = 'path',
  Genially = 'genial_ly',
}

export enum LockLocationType {
  Tag = 'tag',
  TransparentBox = 'transparentBox',
  vsItem = 'vsItem',
  Polygon = 'Polygon',
  vsVideo = 'vsVideo',
  vsImage = 'vsImage',
}
export enum LockLocationTypeLabel {
  tag = 'tag',
  transparentBox = 'transparentBox',
  vsItem = 'VSitem',
}
export enum EntityType {
  Tag = 'tag',
  Sweep = 'sweep',
  Popup = 'popup',
  Polygon = 'polygon',
  VSItem = 'vsItem',
  VSImage = 'vsImage',
  VSVideo = 'vsVideo',
  VSHTML = 'vsHTML',
}
export enum ConditionType {
  HIDE = 'hide',
  REVEAL = 'reveal',
}
export enum HintContentType {
  Text = 'text',
  Picture = 'picture',
  Video = 'video',
}
export enum ContentType {
  Sound = 'sound',
  Picture = 'picture',
  Text = 'text',
  Video = 'video',
  ExperiencePopupImage = 'experiencePopupImage',
  ExperiencePopupVideo = 'experiencePopupVideo',
}
export const LOCK_SOLUTION_SEPARATOR = '|';
export const EMPTY_LOCATION_ITEM = '-1';

const DEFAULT_RES = Res.Pixels;
const DEFAULT_WIDTH = 80;
const DEFAULT_HEIGHT = 60;

export enum FinishScreenTemplate {
  DEFAULT = 'default',
  CUSTOM = 'custom',
}

export class GameGeneral {
  id: number;

  name: string;

  credits: string;

  greetingRes: Res;

  greetingImg: string;

  greetingImgW: string;

  greetingImgH: string;

  greetingImgMob: string;

  greetingImgMobW: string;

  greetingImgMobH: string;

  greetingVideo: string;

  greetingMobVideo: string;

  timerType: GameTimerType;

  limitTime: number;

  timeUpRes: Res;

  timeUpImg: string;

  timeUpImgW: string;

  timeUpImgH: string;

  timeUpImgMob: string;

  timeUpImgMobW: string;

  timeUpImgMobH: string;

  timeUpVideo: string;

  timeUpMobVideo: string;

  scoreType: ScoreType;

  lock_points: number;

  nextHintTime: number;

  scoreHint1: number;

  scoreHint2: number;

  scoreSolution: number;

  tutorialRes: Res;

  tutorialImg: string;

  tutorialImgW: string;

  tutorialImgH: string;

  tutorialImgMob: string;

  tutorialImgMobW: string;

  tutorialImgMobH: string;

  tutorialVideo: string;

  tutorialMobVideo: string;

  autoplayTutorial: boolean;

  subscriptionId: string;

  paid: boolean;

  introClip: boolean;

  introClipUrl: string;

  hideSkipBtn: boolean;

  uploadedIntroUrl: string;

  outroClip: boolean;

  outroClipUrl: string;

  uploadedOutroUrl: string;

  answerIndicatorOn: boolean;

  finishScreenOn: boolean;

  finishScreenType: FinishScreenTemplate;

  finishScreenTitle: string;

  finishScreenShareOn: boolean;

  finishScreenLeaderboardOn: boolean;

  finishScreenCommentOn: boolean;

  finishScreenRateOn: boolean;

  finishScreenImage: string | null;

  timerOn: boolean;

  progressOn: boolean;

  hintsOn: boolean;

  backpackOn: boolean;

  showBackpackByDefault: boolean;

  gameBookOn: boolean;

  buttonSound: boolean;

  buttonSoundUrl: string;

  registration: boolean;

  trial: string;

  updatedAt: any;

  shareResult: boolean;

  constructor(model: any = {}) {
    this.id = model.id || null;
    this.name = model.name || null;
    this.credits = model.credits || null;
    this.greetingRes = model.greetingRes || DEFAULT_RES;
    this.greetingImg = model.greetingImg || null;
    this.greetingImgW = model.greetingImgW || DEFAULT_WIDTH;
    this.greetingImgH = model.greetingImgH || DEFAULT_HEIGHT;
    this.greetingImgMob = model.greetingImgMob || null;
    this.greetingImgMobW = model.greetingImgMobW || DEFAULT_WIDTH;
    this.greetingImgMobH = model.greetingImgMobH || DEFAULT_HEIGHT;
    this.greetingVideo = model.greetingVideo || null;
    this.greetingMobVideo = model.greetingMobVideo || null;

    this.timerType = model.timerType || GameTimerType.CountDown;
    this.limitTime = model.limitTime || 0;
    this.timeUpRes = model.timeUpRes || DEFAULT_RES;
    this.timeUpImg = model.timeUpImg || null;
    this.timeUpImgW = model.timeUpImgW || DEFAULT_WIDTH;
    this.timeUpImgH = model.timeUpImgH || DEFAULT_HEIGHT;
    this.timeUpImgMob = model.timeUpImgMob || null;
    this.timeUpImgMobW = model.timeUpImgMobW || DEFAULT_WIDTH;
    this.timeUpImgMobH = model.timeUpImgMobH || DEFAULT_HEIGHT;
    this.timeUpVideo = model.timeUpVideo || null;
    this.timeUpMobVideo = model.timeUpMobVideo || null;
    this.scoreType = model.scoreType || ScoreType.Progress;

    this.lock_points = model.lock_points || 0;
    this.nextHintTime = model.nextHintTime || 0;
    this.scoreHint1 = model.scoreHint1 || 0;
    this.scoreHint2 = model.scoreHint2 || 0;
    this.scoreSolution = model.scoreSolution || 0;

    this.tutorialRes = model.tutorialRes || DEFAULT_RES;
    this.tutorialImg = model.tutorialImg || null;
    this.tutorialImgW = model.tutorialImgW || DEFAULT_WIDTH;
    this.tutorialImgH = model.tutorialImgH || DEFAULT_HEIGHT;
    this.tutorialImgMob = model.tutorialImgMob || null;
    this.tutorialImgMobW = model.tutorialImgMobW || DEFAULT_WIDTH;
    this.tutorialImgMobH = model.tutorialImgMobH || DEFAULT_HEIGHT;
    this.tutorialVideo = model.tutorialVideo || null;
    this.tutorialMobVideo = model.tutorialMobVideo || null;
    this.autoplayTutorial = model.autoplayTutorial || false;

    this.subscriptionId = model.subscriptionId || null;
    this.paid = model.paid || false;

    this.introClip = model.introClip || false;
    this.introClipUrl = model.introClipUrl || null;
    this.hideSkipBtn = model.hideSkipBtn || null;
    this.uploadedIntroUrl = model.uploadedIntroUrl || '';
    this.outroClip = model.outroClip || false;
    this.outroClipUrl = model.outroClipUrl || null;
    this.uploadedOutroUrl = model.uploadedOutroUrl || '';

    this.answerIndicatorOn = model.answerIndicatorOn || false;
    this.finishScreenOn = model.finishScreenOn || false;
    this.finishScreenType = model.finishScreenType || FinishScreenTemplate.DEFAULT;
    this.finishScreenTitle = model.finishScreenTitle;
    this.finishScreenShareOn = model.finishScreenShareOn ?? false;
    this.finishScreenLeaderboardOn = model.finishScreenLeaderboardOn ?? false;
    this.finishScreenRateOn = model.finishScreenRateOn ?? false;
    this.timerOn = model.timerOn || false;
    this.progressOn = model.progressOn || false;
    this.hintsOn = model.hintsOn || false;
    this.backpackOn = model.backpackOn || false;
    this.showBackpackByDefault = model.showBackpackByDefault || false;
    this.gameBookOn = model.gameBookOn || false;
    this.buttonSound = model.buttonSound || false;
    this.buttonSoundUrl = model.buttonSoundUrl || null;
    this.registration = model.registration || false;
    this.shareResult = model.shareResult || false;
    this.updatedAt = model.updatedAt ? moment(model.updatedAt) : moment();
    this.finishScreenImage = model.finishScreenImage || '';
  }
}
export class GameCondition {
  id: number;

  gameId: number;

  name: string;

  lock_ids: number[];

  isRevealed?: boolean;

  isHidden?: boolean;

  conditionType: ConditionType;

  entity_type: EntityType;

  entity_ids?: string[];

  color?: string;

  teleportToSweep: string;

  teleportLocationType: ConditionLocationType;

  teleportLocationTourLink: string;

  content_type?: ContentType;

  content_value?: string;

  gameBackpack: boolean;

  autoPlay: boolean;

  fullscreen: boolean;

  res: Res;

  resMobile: Res;

  height: number;

  width: number;

  widthMobile: number;

  heightMobile: number;

  experienceTitle: string;

  experienceDescription: string;

  lockPathId: number;

  autoClose: boolean;

  constructor(model: any = {}) {
    this.id = model.id || null;
    this.gameId = model.gameId || null;
    this.name = model.name || null;
    this.lock_ids = model.lock_ids || null;
    this.conditionType = model.conditionType || ConditionType.REVEAL;
    this.entity_type = model.entity_type || null;
    this.entity_ids = model.entity_ids || null;
    this.color = model.color || null;
    this.teleportToSweep = model.teleportToSweep || null;
    this.content_type = model.content_type || ContentType.Text;
    this.content_value = model.content_value || null;
    this.gameBackpack = model.gameBackpack || false;
    this.autoPlay = model.autoPlay || false;
    this.fullscreen = model.fullscreen || false;
    this.res = model.res || Res.Percentage;
    this.resMobile = model.resMobile || Res.Percentage;
    this.width = model.width || 60;
    this.height = model.height || 60;
    this.widthMobile = model.widthMobile || 60;
    this.heightMobile = model.heightMobile || 60;
    this.lockPathId = model.lockPathId || null;
    this.experienceTitle = model.experienceTitle || null;
    this.experienceDescription = model.experienceDescription || null;
    this.autoClose = model.autoClose || false;
    this.teleportLocationType = model.teleportLocationType;
    this.teleportLocationTourLink = model.teleportLocationTourLink;
  }
}

export class GameLockQuestion {
  id: number;

  title: string;

  answer1: string;

  answer2: string;

  answer3: string;

  answer4: string;

  correctAnswer: number;

  constructor(model: any = {}) {
    this.id = model.id || null;
    this.title = model.title || null;
    this.answer1 = model.answer1 || null;
    this.answer2 = model.answer2 || null;
    this.answer3 = model.answer3 || null;
    this.answer4 = model.answer4 || null;
    this.correctAnswer = model.correctAnswer || null;
  }
}

export enum GameLockPathTransitionType {
  FADEOUT = 'fadeout',
  FLY = 'fly',
  INSTANT = 'instant',
  MANUAL = 'manual',
}

export enum LocationSrc {
  chooseSweep = 'chooseSweep',
  tourLink = 'tourLink',
}

export class GameLockPath {
  id: number;

  title: string;

  description: string;

  sweepUuid: string;

  locationType: LockLocationType;

  locationItem: number | string | null;

  triggerType: LockLocationType;

  triggerItem: number | string | null;

  autoOpenDestination: boolean;

  hideStep: boolean;

  locationSrc: string;

  locationSmartLink: string;

  appearanceDelay: number;

  transitionType: GameLockPathTransitionType;

  disableTeleport: boolean;

  disableNextBeforeCompletingTask: boolean;

  icon: string;

  constructor(model: any = {}) {
    this.id = model.id || null;
    this.title = model.title || null;
    this.sweepUuid = model.sweepUuid || null;
    this.description = model.description || null;
    this.locationType = model.locationType || null;
    this.locationItem = model.locationType && model.locationItem ? model.locationItem : null;
    this.triggerType = model.triggerType || null;
    this.autoOpenDestination = model.autoOpenDestination || false;
    this.hideStep = model.hideStep || false;
    this.disableTeleport = model.disableTeleport || false;
    this.disableNextBeforeCompletingTask = model.disableNextBeforeCompletingTask || false;
    this.appearanceDelay = model.appearanceDelay || 0;
    this.locationSrc = model.locationSrc || LocationSrc.chooseSweep;
    this.locationSmartLink = model.locationSmartLink || '';
    this.triggerItem = model.triggerType && model.triggerItem ? model.triggerItem : null;
    this.transitionType = model.transitionType || GameLockPathTransitionType.INSTANT;
    this.icon = model.icon ? `${process.env.REACT_APP_AWS}/${model.icon}` : null;

    if (this.sweepUuid === null && this.locationSmartLink) {
      this.setSweepUuid(this.locationSmartLink);
    }
  }

  private async setSweepUuid(locationSmartLink: string): Promise<void> {
    const res = await parsePathDestinationSweepData({ locationSmartLink, locationSrc: this.locationSrc });

    this.sweepUuid = res?.sweepUuid;
  }
}

class GameLockPathSetting {
  id?: number;

  gameLockId: number;

  colorBackground: string;

  colorText: string;

  colorButton: string;

  colorButtonText?: string;

  opacityBackground: number;

  titleColorText?: string;

  titleOpacityText: number;

  opacityText: number;

  opacityButton: number;

  opacityButtonText?: number;

  icon?: string;

  titleEnabled?: boolean;

  stepEnabled?: boolean;

  defaultPath: boolean;

  resetPathOnSwitch: boolean;

  constructor(model: any) {
    this.id = model?.id || null;
    this.gameLockId = model?.gameLockId || null;
    this.colorBackground = model?.colorBackground || '#ffffff';
    this.colorText = model?.colorText || '#636363';
    this.colorButton = model?.colorButton || '#ea475c';
    this.colorButtonText = model?.colorButtonText || '#ffffff';
    this.opacityBackground = model?.opacityBackground || 0.75;
    this.titleColorText = model?.titleColorText || '#000000';
    this.titleOpacityText = model?.titleOpacityText || 1;
    this.opacityText = model?.opacityText || 1;
    this.opacityButton = model?.opacityButton || 1;
    this.opacityButtonText = model?.opacityButtonText || 1;
    this.icon = model?.icon || null;
    this.titleEnabled = model?.titleEnabled || false;
    this.stepEnabled = model?.stepEnabled || false;
    this.defaultPath = model.defaultPath || false;
    this.resetPathOnSwitch = model.resetPathOnSwitch || false;
  }
}

export class GameLock {
  id: number;

  name: string;

  type: LockType;

  locationType: LockLocationType;

  locationItem: string;

  solution?: string;

  correctMusic?: string;

  incorrectMusic?: string;

  finishMusic?: string;

  questions?: GameLockQuestion[];

  paths?: GameLockPath[];

  keepHighlight?: boolean;

  resetHighlight?: number;

  vsRes: Res;

  vsImg?: string;

  vsImgW?: number;

  vsImgH?: number;

  vsMobImg?: string;

  vsMobImgW?: number;

  vsMobImgH?: number;

  icon?: string;

  hideItems?: string;

  allowSkipping?: boolean;

  last?: boolean;

  timerEnabled?: boolean;

  allowWrongAnswer?: boolean;

  confettiEnabled?: boolean;

  guidCanClose?: boolean;

  lockTimer?: number;

  multipleAttempts?: boolean;

  lockPopUpCanBeClosed?: boolean;

  guidCanBeClosed?: boolean;

  quantityOfAttempts?: number;

  point: number;

  description: string;

  pathSetting: GameLockPathSetting;

  collected: string[];

  hint: GameHint | null;

  previousStep: boolean;

  url: string;

  mobileUrl: string;

  buttonOnlyMode: boolean;

  nextButtonVisibility: TLocksButtonVisibility;

  pathSwitcher: any;

  endPathIcon: boolean;

  constructor(model: any = {}) {
    this.id = model.id || null;
    this.name = model.name || null;
    this.type = model.type || null;
    this.url = model.url || null;
    this.mobileUrl = model.mobileUrl || null;
    this.locationType = model.locationType || null;
    this.locationItem = model.locationItem || null;
    this.solution = model.solution || null;
    this.correctMusic = model.correctMusic || null;
    this.incorrectMusic = model.incorrectMusic || null;
    this.finishMusic = model.finishMusic || null;
    this.questions = (model.questions && model.questions.map((question: any) => new GameLockQuestion(question))) || [];
    this.paths = (model?.paths || []).map((path: any) => new GameLockPath(path));

    this.keepHighlight = model?.keepHighlight ?? true;
    this.resetHighlight = model.resetHighlight || 0;
    this.vsRes = model.vsRes || Res.Percentage;
    this.vsImg = model.vsImg || null;
    this.vsImgW = model.vsImgW || DEFAULT_WIDTH;
    this.vsImgH = model.vsImgH || DEFAULT_HEIGHT;
    this.vsMobImg = model.vsMobImg || null;
    this.vsMobImgW = model.vsMobImgW || DEFAULT_WIDTH;
    this.vsMobImgH = model.vsMobImgH || DEFAULT_HEIGHT;
    this.collected = [];
    this.icon = model.icon || null;
    this.hideItems = model.hideItems ?? false;
    this.allowSkipping = model.allowSkipping ?? false;
    this.last = model.last ?? false;
    this.point = model.point || 0;
    this.timerEnabled = model.timerEnabled ?? false;
    this.allowWrongAnswer = model.allowWrongAnswer ?? false;
    this.confettiEnabled = model.confettiEnabled ?? false;
    this.guidCanClose = model.guidCanClose ?? false;
    this.lockTimer = model.lockTimer ?? 0;
    this.multipleAttempts = model.multipleAttempts ?? false;
    this.lockPopUpCanBeClosed = model.lockPopUpCanBeClosed ?? false;
    this.guidCanBeClosed = model.guidCanBeClosed ?? false;
    this.quantityOfAttempts = model.quantityOfAttempts ?? 0;
    const pS = model.pathSetting || {};
    this.pathSetting = new GameLockPathSetting({ ...pS, stepEnabled: model.stepEnabled, titleEnabled: model.titleEnabled });
    this.hint = model.hint || null;
    this.description = model.description || '';
    this.previousStep = model.previousStep || false;
    this.buttonOnlyMode = model.buttonOnlyMode || false;
    this.nextButtonVisibility = model.nextButtonVisibility || TLocksButtonVisibility.ShowAll;
    this.pathSwitcher = model.pathSwitcher || null;
    this.endPathIcon = model.endPathIcon || false;
  }
}

export class GameHint {
  id: number;

  gameId: number;

  lockId?: number;

  name: string;

  hint1_active?: boolean;

  hint1_type?: HintContentType;

  hint1_value?: string;

  hint1_deductPoints?: number;

  hint1_unlockTime?: number;

  hint2_active?: boolean;

  hint2_type?: HintContentType;

  hint2_value?: string;

  hint2_deductPoints?: number;

  hint2_unlockTime?: number;

  solution_active?: boolean;

  solution_type?: HintContentType;

  solution_value?: string;

  solution_deductPoints?: number;

  solution_unlockTime?: number;

  constructor(model: any = {}) {
    this.id = model.id || null;
    this.gameId = model.gameId || null;
    this.name = model.name || null;
    this.lockId = model.lockId || null;

    this.hint1_active = model.hint1_active || false;
    this.hint1_type = model.hint1_type || null;
    this.hint1_value = model.hint1_value || null;
    this.hint1_deductPoints = model.hint1_deductPoints || 0;
    this.hint1_unlockTime = model.hint1_unlockTime || 0;

    this.hint2_active = model.hint2_active || false;
    this.hint2_type = model.hint2_type || null;
    this.hint2_value = model.hint2_value || null;
    this.hint2_deductPoints = model.hint2_deductPoints || 0;
    this.hint2_unlockTime = model.hint2_unlockTime || 0;

    this.solution_active = model.solution_active || false;
    this.solution_type = model.solution_type || null;
    this.solution_value = model.solution_value || null;
    this.solution_deductPoints = model.solution_deductPoints || 0;
    this.solution_unlockTime = model.solution_unlockTime || 0;
  }
}
export class Game extends GameGeneral {
  id: number;

  locks: GameLock[];

  hints: GameHint[];

  conditions: GameCondition[];

  book: GameBook;

  paths: GameLock[];

  constructor(model: any = {}) {
    super(model);
    const paths = (model?.locks || []).filter((lock) => lock.type === LockType.Path);
    this.id = model.id || null;
    this.locks = (model.locks?.length && model.locks.filter((lock) => lock.type !== LockType.Path).map((lock: any) => new GameLock(lock))) || [];
    this.paths = paths.length ? paths.map((p) => new GameLock(p)) : null;
    this.hints = (model.hints && model.hints.map((hint: any) => new GameHint(hint))) || [];
    this.conditions = (model.conditions && model.conditions.map((condition: any) => new GameCondition(condition))) || [];
    this.book = model.book ? new GameBook(model.book) : null;
  }
}
